import { useState } from "react";

import { Grid, Typography } from "@mui/material";

import { TextField, LoadingButton } from "@aclymatepackages/atoms";
import { editObjectData } from "@aclymatepackages/array-immutability-helpers";

import { sendSupportEmail } from "../../helpers/utils/apiCalls";

const SupportEmailForm = ({
  email,
  userName,
  companyName,
  subject: initialSubject = "",
  message: initialMessage = "",
  onSent,
}) => {
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [sendEmailLoading, setSendEmailLoading] = useState(false);
  const [inputData, setInputData] = useState({
    subject: initialSubject,
    message: initialMessage,
  });
  const { subject, message, email: inputEmail } = inputData;

  const editInputData = (field) => (value) =>
    editObjectData(setInputData, field, value);

  const onEmailSend = () => {
    setSendEmailLoading(true);
    return sendSupportEmail({
      name: userName,
      email: email || inputEmail,
      companyName,
      subject,
      message,
      callback: () => {
        setIsEmailSent(true);
        setSendEmailLoading(false);
        if (onSent) onSent();
      },
    });
  };

  return (
    <Grid container direction="column" spacing={2} wrap="nowrap" sx={{ p: 2 }}>
      <Grid item sm={12}>
        <Typography variant="h6" color="textPrimary">
          Email us directly
        </Typography>
      </Grid>
      {!email && (
        <Grid item sm={12}>
          <TextField
            label="Email"
            value={inputEmail}
            setValue={editInputData("email")}
          />
        </Grid>
      )}
      <Grid item sm={12}>
        <TextField
          label="Subject"
          value={subject}
          setValue={editInputData("subject")}
        />
      </Grid>
      <Grid item sm={12}>
        <TextField
          label="Message"
          multiline
          rows={10}
          value={message}
          setValue={editInputData("message")}
        />
      </Grid>
      {isEmailSent && (
        <Grid item>
          <Typography variant="subtitle2" color="textSecondary" align="center">
            We&apos;ve received your email and we&apos;ll get back to you within one work
            day
          </Typography>
        </Grid>
      )}
      <Grid item container justifyContent="center">
        <LoadingButton
          isLoading={sendEmailLoading}
          variant="contained"
          color="secondary"
          disabled={
            !subject || !message || isEmailSent || !(email || inputEmail)
          }
          onClick={onEmailSend}
          label="Email Support"
        />
      </Grid>
    </Grid>
  );
};

export default SupportEmailForm;
